import React from 'react';

const TableImageIcon = ({ note, isLoading, onClick }) => {
  const imageCount = note.inlineImageCount || 0;
  if (!imageCount) return null;

  if (isLoading) {
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '6px' }}>
        <i className="fas fa-spinner fa-spin" style={{ fontSize: '12px', color: '#666' }} />
      </div>
    );
  }

  return (
    <div
      className="inline-image-icon"
      style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '6px', cursor: 'pointer', position: 'relative' }}
      onClick={(e) => { e.stopPropagation(); onClick(note); }}
      title={`${imageCount} inline image${imageCount !== 1 ? 's' : ''} - Click to view`}
    >
      <div style={{ position: 'relative' }}>
        <i
          className="fas fa-image"
          style={{ fontSize: '16px', color: '#3498db', transition: 'all 0.2s ease' }}
          onMouseEnter={(e) => { e.target.style.transform = 'scale(1.2)'; e.target.style.color = '#2980b9'; }}
          onMouseLeave={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.color = '#3498db'; }}
        />
      </div>
    </div>
  );
};

export default React.memo(TableImageIcon);